export const isSafari = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
export const isFirefox = navigator.userAgent.indexOf('Firefox') !== -1;
const ftext = (() => {
  const input = document.createElement('textarea');
  input.setAttribute('style', 'position:fixed;left:0;top:0;opacity:0.01;width:5px;height:10px;');
  return input;
})();
let internalClipboard = '';
function activeFtext() {
  const focus1 = document.activeElement;
  const newParent = focus1.hasChildNodes() ? focus1 : focus1.parentElement;
  newParent.appendChild(ftext);
  setTimeout(() => {
    if (ftext.parentElement === newParent) {
      document.body.appendChild(ftext);
      focus1.focus();
    }
  }, 50);
}
export function writeClipboard(text) {
  activeFtext();
  internalClipboard = text;
  ftext.value = text;
  ftext.select();
  document.execCommand('copy');
}

/**
 * @return {Promise<string>}
 */
export async function readClipboard() {
  if (!window.navigator.clipboard) {
    // 有些页面他就是没有clipboard 怎么办? 就不提示了 提示了也没用
    return internalClipboard;
  }
  return Promise.race([Promise.resolve().then(() => navigator.clipboard.readText()),
  // 常规剪贴板方法
  new Promise((res, rej) => {
    setTimeout(() => rej('Timeout'), 1500); // 超时
  })]).catch(err => {
    if (!silentErrorMessages.has(err.message)) {
      silentErrorMessages.add(err.message);
      console.error('[UICore] cannot read clipboard. Using internal cache', err);
    }
    return internalClipboard;
  });
}
const silentErrorMessages = new Set();
//# sourceMappingURL=clipboard.js.map
